import React from "react";
import qs from "querystring";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {MapContainer, TileLayer, Marker, useMapEvents, useMap} from 'react-leaflet';
import L from 'leaflet';
import ICON from 'leaflet/src/images/marker.green.min.svg';
import {BASE_URL, AREAS_VALIDATE_POINT_POST} from "apis";
import {BiCurrentLocation} from "react-icons/all";
import axios from "axios";
import {actionChangeLocationModalAddAddress} from "../../../../redux/actions/modals/modalAddAddress";
import {actionChangeLocationModalEditAddress} from "../../../../redux/actions/modals/address/modalEditAddress";
import {actionChangeDataFindLocation, actionChangeLoaderFindLocationMap} from "../../../../redux/actions/partals/map";



const LeafletMap = (props) => {
    
    const dispatch = useDispatch();

    let btnCurrentLocClick = false;






    const {type} = props.data;

    const {lng, lat} = useSelector(state => {
        return (typeof type !== "undefined" && type === 'EDIT') ? state.modalEditAddress : state.modalAddAddress;
    });
    const {findLocation, loaderFindLocation} = useSelector(state => state.map);






    setTimeout(function () {
       window.dispatchEvent(new Event('resize'));
    }, 100);
    

    const handleValidateLocation = async (glat, glng) => {
        try {
            const response = await axios.post(BASE_URL + AREAS_VALIDATE_POINT_POST, qs.stringify({glat, glng}));

            const {data} = response;
            if (data.status === 'ok') {
                setLatAndLng(glng, glat);
            } else {
                toast.error(`${response.data.message}`, {position: toast.POSITION.BOTTOM_CENTER});
            }
        } catch (e) {
            console.log(e);
        }
    };

    const setLatAndLng = (glng, glat) => {
        if (typeof type !== "undefined" && type === 'EDIT') {
            dispatch(actionChangeLocationModalEditAddress(glng, glat));
        } else {
            dispatch(actionChangeLocationModalAddAddress(glng, glat));
        }
        dispatch(actionChangeDataFindLocation(glat, glng));
        toast.success(`آدرس مورد نظر انتخاب شد`, {position: toast.POSITION.BOTTOM_CENTER});
    }


    




















    function ChangeView({center}: any) {
        console.log("change viewwwww");
        const map = useMap();
        map.setView(center);
        return null;
    }

    function MyComponent() {
                
        

        useMapEvents({
            click: ({latlng}) => {
                setTimeout(function () {
                    if(! btnCurrentLocClick) {
                        handleValidateLocation(latlng.lat, latlng.lng);
                    }
                        
                }, 100);
                
            }
        })

        return null;
    }


    const CurrentLocationControl = () => {
        return (
            <div className='leaflet-bottom leaflet-left' style={{zIndex: "99999"}}>
                <div className="leaflet-control leaflet-bar">
                    <div className='btn-my-location' onClick={handleCurrentLocation}>
                        <BiCurrentLocation size={30} style={{background: "white"}}/>
                    </div>
                </div>
            </div>
        )
    }

    const handleCurrentLocation = () => {
        btnCurrentLocClick = true;

        if (!loaderFindLocation) {
            dispatch(actionChangeLoaderFindLocationMap(true));
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((response) => {
                    const {latitude, longitude}: any = response.coords;
                    //handleValidateLocation(latitude, longitude);

                    dispatch(actionChangeDataFindLocation(latitude, longitude));

                    btnCurrentLocClick = false;

                    dispatch(actionChangeLoaderFindLocationMap(false));
                }, (error) => {
                    toast.error('خطا در دریافت موقعیت مکانی!', {position: toast.POSITION.BOTTOM_CENTER});
                    dispatch(actionChangeLoaderFindLocationMap(false));
                });
            } else {
                toast.error('لطفا مجددا تلاش کنید.');
                btnCurrentLocClick = false;

                dispatch(actionChangeLoaderFindLocationMap(false));
            }
        }
            

        return false;
    }

    const handleMoveEnd = () => {
        console.log("move end");
    }

    const handleMove = () => {
        console.log("handleMove");
    }
    

    return (
        <MapContainer center={findLocation} zoom={14} onMoveEnd={handleMoveEnd} move={handleMove} noMoveStart={handleMove}
                      scrollWheelZoom={false} style={{height: '100%', zIndex: 1}} >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
            {/*((LOCA.glat || LOCA.glng) || arraySelectZone) &&
            <Marker
                position={(lat || lng) ? [lat, lng] : findLocation}
                icon={new L.Icon({iconUrl: ICON, iconAnchor: [15, 45]})}/>
            */
            ((lat || lng) || findLocation) &&
            <Marker
                position={(lat || lng) ? [lat, lng] : [0, 0]}
                icon={new L.Icon({iconUrl: ICON, iconAnchor: [20, 50], iconSize: [40, 50], className: 'leaflet-marker-icon'})}/>}
            {((lat && lng) || findLocation) &&
            <ChangeView center={(lat && lng) ? [lat, lng] : findLocation} onMoveEnd={handleMoveEnd} move={handleMove}/>
            }
            <MyComponent/>

            <CurrentLocationControl/>

        </MapContainer>
    );

};

export default LeafletMap;
